import {
  Box,
  Grid,
  Paper,
  Button,
  useTheme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import HealthCare from "../../assets/images/Travel/HealthCare.png";
import HealthIssue from "../../assets/images/Travel/HealthIssue.png";
import Luggage from "../../assets/images/Travel/Luggage.png";
import Passport from "../../assets/images/Travel/Passport.png";
import TravelBag from "../../assets/images/Travel/TravelBag.png";
import Travelling from "../../assets/images/Travel/Travelling.png";

const REASONS_LIST = [
  {
    icon: TravelBag,
    heading: "Travel",
    text: "Airports process over 4 billion bags yearly, but human and technical errors cause 28 million to be mishandled..",
  },
  {
    icon: HealthCare,
    heading: "Health Care",
    text: "Medical treatment expenses worldwide have seen a sharp 30% rise post-pandemic, making travel insurance more essential than ever.",
  },
  {
    icon: Luggage,
    heading: "Luggage Protection",
    text: "Checked-in luggage issues such as delays or damage still affect frequent flyers, making baggage protection essential.",
  },
  {
    icon: Passport,
    heading: "Passport Protection",
    text: "Approximately 300,000 passports are lost or stolen annually while travelling abroad.",
  },
  {
    icon: Travelling,
    heading: "Delay Travelling",
    text: "Flight delays and missed connections are frequent in tourist-dense destinations, often disrupting travel plans unexpectedly.",
  },
  {
    icon: HealthIssue,
    heading: "Health Issues",
    text: "Almost half of all international travellers face health issues during their trip, making medical coverage a crucial safety net.",
  },
];

const TravelReasonCard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        py: 8,
        px: { xs: 2, sm: 4, md: 8 },
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        mb={5}
        sx={{ fontWeight: 600, fontFamily: '"Poppins", serif' }}
      >
        Reasons to Buy Travel Insurance
      </Typography>

      <Grid container spacing={2} justifyContent="center">
        {REASONS_LIST.map((item, index) => (
          <Grid key={index} item xs={12} sm={6} md={4}>
            <Paper
              mb={2}
              elevation={1}
              sx={{
                py: 3,
                px: 2,
                width: { xs: "440px", sm: "320px", md: "360px" },
                height: { xs: "140px", sm: "165px", md: "180px" },
                borderRadius: 4,
                bgcolor: "#fff",
                textAlign: "left",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: 4,
                },
              }}
            >
              <Box mb={2} display="flex" alignItems="center">
                <img src={item.icon} alt="icon" width={60} />
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: '"Poppins", serif',
                    ml: 2,
                  }}
                >
                  {item.heading}{" "}
                  {/* Make sure REASONS_LIST includes a heading */}
                </Typography>
              </Box>
              <Typography
                variant="body1"
                sx={{ fontFamily: '"Poppins", serif' }}
              >
                {item.text}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Button
        variant="contained"
        color="success"
        sx={{ mt: 6, textTransform: "none", fontWeight: "bold" }}
      >
        Get Travel Insurance
      </Button>
    </Box>
  );
};

export default TravelReasonCard;
